import React from "react";

import { Box, CircularProgress, Grid } from "@mui/material";

export const UserFieldsLoader = () => {
  return (
    <Grid
      data-testid="user-field-table-loader"
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "1.5rem",
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "inline-flex",
        }}
      >
        <CircularProgress
          color="primary"
          variant="indeterminate"
          thickness={4}
          size={50}
        />
      </Box>
    </Grid>
  );
};
